<div class="mb-28 flex h-[325px] w-[325px] items-center sm:mb-0">
    <canvas
        baseChart
        [datasets]="$any(chartDataSets())"
        [labels]="chartLabels()"
        [options]="$any(chartOption)"
        [type]="CHART_TYPE"
        [plugins]="[CENTER_TEXT_PLUGIN, DOUGHNUT_LABEL_LINE]"></canvas>
</div>
